import React, { memo } from 'react';
import { Button, ButtonGroup, Gold, TooltipBody } from '@wg/wows-react-uikit';

import { t } from '~/helpers/localization';

import styles from './ClanNameEditDialog.scss';

interface ClanNameEditFooterProps {
  cost: number;
  button: {
    disabled: boolean;
    tooltip: React.ReactNode;
    loading: boolean;
    onSubmit: () => void;
  };
  isLoading: boolean;
  onCancel: () => void;
}

const ClanNameEditFooter: React.FC<ClanNameEditFooterProps> = ({
  cost,
  button: { disabled, tooltip, loading, onSubmit },
  isLoading,
  onCancel,
}) => (
  <div className={styles.footer}>
    <div className={styles.priceLabel}>{t('Стоимость')}:</div>
    <Gold className={styles.price} amount={cost} />
    <ButtonGroup isLoading={loading} spinnerLabel={t('Переименовываем клан')} textAlign={'left'}>
      <Button
        isFlat
        isDisabled={disabled || isLoading}
        onClick={onSubmit}
        tooltipContent={tooltip && <TooltipBody>{tooltip}</TooltipBody>}
      >
        {t('Сохранить')}
      </Button>
      <Button isJustified isFlat onClick={onCancel}>
        {t('Отменить')}
      </Button>
    </ButtonGroup>
  </div>
);

export default memo(ClanNameEditFooter);
